import type { MediaCropArea } from '#src/app/shared/hooks/imageUpload';
import { getMinImageDimensionSize } from '#src/app/shared/utils/uppyUploader';

export const validateImageSize = (imageData?: MediaCropArea): boolean => {
	if (!imageData) return false;
	const minImageDimensionSize = getMinImageDimensionSize();
	return imageData.h > minImageDimensionSize.HEIGHT || imageData.w > minImageDimensionSize.WIDTH;
};
